import React, { Component, Fragment } from 'react';
import { connect } from "react-redux";
import { IRootState } from "../../../store";
import DispatchProps from "../../../utils/DispatchProps";
import {
    CommandBarButton,
    Dropdown,
    IDropdownOption,
    MessageBarType,
} from "office-ui-fabric-react";
import ApiService from "../../ApiService";
import {
    Client as GraphClient,
} from "@microsoft/microsoft-graph-client";
import Actions from "../../../redux/Actions";
import H from "history";
import { UserAccessLevel } from '../../../models/UserAccessRecord';
import PageTitle from '../../PageTitle';
import { UserOption } from '../../UserSelectorBase';
import UserSelectorCDB from '../../UserSelectorCDB';

interface AddUserAccessRecordPageProps {
    apiService: ApiService;
    graphClient: GraphClient;
    history: H.History;
}

interface AddUserAccessRecordPageState {
    selectedUsers: UserOption[];
    selectedLevel: UserAccessLevel;
}

class AddUserAccessRecordPage extends Component<AddUserAccessRecordPageProps & DispatchProps, AddUserAccessRecordPageState> {
    static displayName = AddUserAccessRecordPage.name;

    private static accessLevelOptions: IDropdownOption[] = [
        {
            key: "admin",
            text: "Admin",
        },
        {
            key: "engineerplus",
            text: "EngineerPlus"
        },
        {
            key: "engineer",
            text: "Engineer"
        },
        {
            key: "employee",
            text: "Employee"
        },
    ]

    constructor(props: AddUserAccessRecordPageProps & DispatchProps) {
        super(props);

        this.state = {
            selectedUsers: [],
            selectedLevel: "admin"
        }
    }

    async componentDidMount() {

    }

    protected submitForm = async () => {
        try {
            await Promise.all(this.state.selectedUsers.map((userOption) => {
                return this.props.apiService.createUserAccessRecord({
                    userOid: userOption.id,
                    level: this.state.selectedLevel
                });
            }));

            this.props.dispatch(Actions.showMessageBar("Saved successfully", MessageBarType.success));
            this.props.history.push(`/cdb-admin/user-access`);
        }
        catch (e) {
            this.props.dispatch(Actions.showMessageBar("Failed to save access", MessageBarType.error));
        }
    };

    componentDidUpdate(prevProps: Readonly<AddUserAccessRecordPageProps & DispatchProps>, prevState: any): void {

    }

    render() {
        return (
            <Fragment>
                <PageTitle title={`Add User Access`} />

                <div className="card card">

                    <div className="card__header">

                        <span className={"card__title"}>Give users access</span>

                        <CommandBarButton
                            iconProps={{ iconName: "save" }}
                            text="Save"
                            onClick={this.submitForm}
                        />
                    </div>

                    <div className="card__content flex-column">

                        <Dropdown
                            label="Access Level"
                            selectedKey={this.state.selectedLevel}
                            onChange={(event: any, option?: IDropdownOption) => {
                                this.setState({
                                    selectedLevel: option!.key as UserAccessLevel
                                });
                            }}
                            placeholder="Select Access Level"
                            options={AddUserAccessRecordPage.accessLevelOptions}
                        />

                        <UserSelectorCDB
                            className="card__input"
                            disabled={false}
                            multiSelect={true}
                            label={"Users"}
                            selectedUsers={this.state.selectedUsers}
                            onSelectionChanged={(selectedUsers: UserOption[]) => {
                                this.setState({
                                    selectedUsers
                                });
                            }} />
                    </div>

                </div>
            </Fragment>
        );
    }
}

export default connect(
    (state: IRootState, ownProps: { match: any, history: H.History }): AddUserAccessRecordPageProps => {

        return {
            graphClient: state.auth.graphClient,
            apiService: state.auth.apiService,
            history: ownProps.history
        };
    }
)(AddUserAccessRecordPage)